import React, { ReactNode } from 'react'

/** Article-specific shell: fields stay visible, including validation messages. */
const ArticleSection = ({
    title,
    description,
    icon: Icon,
    children,
}: {
    title: string
    description?: string
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
    children: ReactNode
}) => (
    <section className="article-panel" aria-label={title}>
        <div className="article-panel-heading">
            <div className="flex items-center gap-2">
                <Icon
                    className="h-4 w-4 shrink-0 text-blue-600 dark:text-blue-400"
                    aria-hidden="true"
                />
                <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-100">
                    {title}
                </h3>
            </div>
            {description && (
                <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
                    {description}
                </p>
            )}
        </div>
        <div className="article-panel-body">{children}</div>
    </section>
)

export default ArticleSection
